import { GamingAggregatorStatusId } from '@/models/gaming-aggregator/status/id';
import { GamesPannelGameButtonProps } from './props';

import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
export default function GamesPannelGameButton({
  status,
  gameButton,
  game,
  aggregator,
}: GamesPannelGameButtonProps) {
  const { t } = useTranslation('common');
  // if (status !== GamingAggregatorStatusId.Active?.toString()) {
  //   return (
  //     <div className={styles.container}>
  //       <div className={styles.container__content}>
  //         <i
  //           className={`${styles.container__content__icon} fa-solid fa-warning`}
  //         />
  //         <p className={styles.container__content__label}>
  //           {t('unavailable_game_by_status', {
  //             aggregator: aggregator?.name,
  //             game: game?.name,
  //           })}
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  return gameButton;
}
